/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <pre><code>Represents different UI form field controls like Select, RadioButton, Date Picker etc.,
 * <\/code><\/pre>
 **/
export var FormFieldControlType;
(function (FormFieldControlType) {
    FormFieldControlType["SELECT"] = "SELECT";
    FormFieldControlType["DATE_PICKER"] = "DATE_PICKER";
    FormFieldControlType["LINK"] = "LINK";
    FormFieldControlType["FILE"] = "FILE";
    FormFieldControlType["TEXT"] = "TEXT";
})(FormFieldControlType || (FormFieldControlType = {}));
